import { useEffect } from 'react'

const FOTO_MONICA = 'https://static.lumi.new/b2/b2c0441cd263f605e6a1cd0bab42c1dc.webp'

const REDES = [
  {
    nome: 'YouTube',
    href: 'https://youtube.com/@descobrindoosaromas',
    icone: (
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor" aria-hidden="true">
        <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31.5 31.5 0 0 0 0 12a31.5 31.5 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31.5 31.5 0 0 0 24 12a31.5 31.5 0 0 0-.5-5.8zM9.8 15.5v-7l6.3 3.5-6.3 3.5z" />
      </svg>
    ),
  },
  {
    nome: 'WhatsApp',
    href: 'https://wa.me/5581988671210',
    icone: (
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor" aria-hidden="true">
        <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.7 14.4c-.2.7-1.3 1.2-1.8 1.3-.5.1-1 .2-1.7-.1-.4-.2-.9-.3-1.5-.6-2.7-1.2-4.4-3.9-4.6-4.1-.1-.2-1.1-1.5-1.1-2.8s.7-2 1-2.2c.2-.2.5-.3.8-.3h.6c.2 0 .4 0 .6.5l.9 2.1c.1.2.1.4 0 .6l-.4.7c-.1.2-.3.4-.1.7.1.3.6 1 1.3 1.6.9.8 1.6 1 1.9 1.1.3.1.5.1.7-.1l.9-1.1c.2-.2.4-.2.6-.1l2.2.9c.2.1.4.2.4.5 0 .1 0 .7-.2 1.4z" />
      </svg>
    ),
  },
  {
    nome: 'Instagram',
    href: 'https://www.instagram.com/descobrindoosaromas',
    icone: (
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    nome: 'TikTok',
    href: 'https://www.tiktok.com/@descobrindoosaromas',
    icone: (
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor" aria-hidden="true">
        <path d="M14.2 3c.4 2.6 1.9 4.4 4.4 4.7v3.1c-1.5 0-2.9-.5-4.1-1.4v6.4c0 3.4-2.7 6.2-6.2 6.2S2.1 19.2 2.1 15.7 4.8 9.5 8.3 9.5c.4 0 .8 0 1.2.1v3.2c-.4-.1-.8-.2-1.2-.2-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1 3.1-1.4 3.1-3.1V3h2.8z" />
      </svg>
    ),
  },
]

const LINKS = [
  {
    titulo: 'Jornada das 12 Emoções',
    subtitulo: '12 vivências com óleos essenciais para liberar o que te prende',
    href: 'https://descubraseusoleos.com.br/jornada12emocoes',
  },
  {
    titulo: 'Diagnóstico Gratuito - Adulto',
    subtitulo: 'Descubra quais óleos essenciais são indicados para você',
    href: 'https://www.descubraseusoleos.com.br/?c=monica',
  },
  {
    titulo: 'Diagnóstico Gratuito - Crianças',
    subtitulo: 'Descubra quais óleos são indicados para seu filho(a)',
    href: 'https://www.descubraseusoleos.com.br/kids?c=monica',
  },
  {
    titulo: 'Quero Comprar os Óleos dōTERRA',
    href: 'https://doterra.me/AHXLg8',
  },
  {
    titulo: 'Atendimento Online de Aromaterapia',
    href: 'https://go.hotmart.com/B94246513D?dp=1',
  },
  {
    titulo: 'Promoções de Óleos Essenciais',
    subtitulo: 'Grupo de WhatsApp',
    href: 'https://chat.whatsapp.com/HkzEjGHRfMp7Fs9H4GHngt?s=cl&p=a&mlu=4&ilr=4&iam=0',
  },
  {
    titulo: 'Sistema Descubra seus Óleos',
    subtitulo: 'Para consultoras, terapeutas e aromaterapeutas: atenda seus clientes com poucos cliques.',
    href: 'https://descubraseusoleos.com.br',
  },
]

export default function Bio() {
  useEffect(() => {
    document.title = 'Mônica Maria — Diagnóstico Saúde e Emoções'
    const html = document.documentElement
    const tamanhoAnterior = html.style.fontSize
    html.style.fontSize = '18px'
    return () => {
      html.style.fontSize = tamanhoAnterior
    }
  }, [])

  return (
    <div className="min-h-screen bg-[#E8F2EC] flex flex-col">
      <main className="flex-1 px-4 py-5 sm:py-8 md:px-6">
        <div className="mx-auto w-full max-w-[540px] text-center">
          <img
            src={FOTO_MONICA}
            alt="Mônica Maria, aromaterapeuta e consultora dōTERRA"
            width={112}
            height={112}
            className="mx-auto mb-2.5 h-24 w-24 md:h-28 md:w-28 rounded-full object-cover border-[3px] border-[#C9A84C] shadow-sm"
            fetchPriority="high"
          />

          <h1 className="font-cormorant text-[2.2rem] md:text-[3rem] leading-[1.15] font-semibold text-[#1D5C3A]">
            Mônica Maria
          </h1>

          <p className="mt-2 font-dm-sans text-[0.8rem] font-medium uppercase tracking-[0.08em] text-[#C9A84C] leading-snug">
            AROMATERAPEUTA VIBRACIONAL
            <span className="hidden sm:inline"> · </span>
            <span className="block sm:inline">CONSULTORA dōTERRA</span>
          </p>

          <p className="mt-4 font-cormorant text-[1.1rem] font-medium leading-[1.5] text-[#1D5C3A]">
            Te guio para liberar seus bloqueios emocionais com os óleos essenciais.
          </p>

          <nav aria-label="Redes sociais" className="mt-3.5 mb-4 flex items-center justify-center gap-3">
            {REDES.map(rede => (
              <a
                key={rede.nome}
                href={rede.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={rede.nome}
                className="flex h-12 w-12 items-center justify-center rounded-full bg-[#1D5C3A] text-white hover:bg-[#164a2e] focus:outline-none focus:ring-2 focus:ring-[#C9A84C] focus:ring-offset-2 focus:ring-offset-[#E8F2EC] transition-colors"
              >
                {rede.icone}
              </a>
            ))}
          </nav>

          <div className="flex flex-col gap-3">
            {LINKS.map(link => (
              <a
                key={link.titulo}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full rounded-[40px] bg-[#1D5C3A] text-white px-5 py-[14px] hover:bg-[#164a2e] focus:outline-none focus:ring-2 focus:ring-[#C9A84C] focus:ring-offset-2 focus:ring-offset-[#E8F2EC] transition-colors"
              >
                <span className="block font-dm-sans font-bold text-[1rem] leading-snug">
                  {link.titulo}
                </span>
                {link.subtitulo ? (
                  <span className="mt-1 block font-dm-sans font-normal text-[0.85rem] leading-snug text-white/75">
                    {link.subtitulo}
                  </span>
                ) : null}
              </a>
            ))}
          </div>
        </div>
      </main>
    </div>
  )
}
